/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as publicPublicImport } from './routes/(public)/_public'
import { Route as dashboardSupplementaryImport } from './routes/(dashboard)/supplementary'
import { Route as dashboardQuestionnaireImport } from './routes/(dashboard)/questionnaire'
import { Route as dashboardDashboardImport } from './routes/(dashboard)/dashboard'
import { Route as publicPublicIndexImport } from './routes/(public)/_public/index'
import { Route as dashboardDashboardIndexImport } from './routes/(dashboard)/dashboard/index'
import { Route as publicPublicWelcomeImport } from './routes/(public)/_public/welcome'
import { Route as publicPublicTermsImport } from './routes/(public)/_public/terms'
import { Route as publicPublicPrivacyPolicyImport } from './routes/(public)/_public/privacy-policy'
import { Route as publicPublicLiveConsultationImport } from './routes/(public)/_public/live-consultation'
import { Route as publicPublicContactImport } from './routes/(public)/_public/contact'
import { Route as publicPublicConsultationsImport } from './routes/(public)/_public/consultations'
import { Route as publicPublicAppointmentsImport } from './routes/(public)/_public/appointments'
import { Route as dashboardDashboardWeightLossImport } from './routes/(dashboard)/dashboard/weight-loss'
import { Route as dashboardDashboardUrgentCareImport } from './routes/(dashboard)/dashboard/urgent-care'
import { Route as dashboardDashboardSupplementaryImport } from './routes/(dashboard)/dashboard/supplementary'
import { Route as dashboardDashboardSettingsImport } from './routes/(dashboard)/dashboard/settings'
import { Route as dashboardDashboardOnboardingImport } from './routes/(dashboard)/dashboard/onboarding'
import { Route as dashboardDashboardMedicalsImport } from './routes/(dashboard)/dashboard/medicals'
import { Route as publicPublicConsultationsIndexImport } from './routes/(public)/_public/consultations/index'
import { Route as publicPublicAppointmentsIndexImport } from './routes/(public)/_public/appointments/index'
import { Route as dashboardDashboardWeightLossIndexImport } from './routes/(dashboard)/dashboard/weight-loss/index'
import { Route as dashboardDashboardUrgentCareIndexImport } from './routes/(dashboard)/dashboard/urgent-care/index'
import { Route as dashboardDashboardSupportIndexImport } from './routes/(dashboard)/dashboard/support/index'
import { Route as dashboardDashboardSettingsIndexImport } from './routes/(dashboard)/dashboard/settings/index'
import { Route as dashboardDashboardOnboardingIndexImport } from './routes/(dashboard)/dashboard/onboarding/index'
import { Route as dashboardDashboardMedicalsIndexImport } from './routes/(dashboard)/dashboard/medicals/index'
import { Route as publicPublicConsultationsErrorImport } from './routes/(public)/_public/consultations/error'
import { Route as publicPublicConsultationsConfirmationImport } from './routes/(public)/_public/consultations/confirmation'
import { Route as publicPublicAppointmentsErrorImport } from './routes/(public)/_public/appointments/error'
import { Route as publicPublicAppointmentsConfirmationImport } from './routes/(public)/_public/appointments/confirmation'
import { Route as dashboardDashboardWeightLossMedicalsImport } from './routes/(dashboard)/dashboard/weight-loss/medicals'
import { Route as dashboardDashboardWeightLossAppointmentsImport } from './routes/(dashboard)/dashboard/weight-loss/appointments'
import { Route as dashboardDashboardMedicalsProgramRouteImport } from './routes/(dashboard)/dashboard/medicals/$program/route'
import { Route as dashboardDashboardWeightLossSupportIndexImport } from './routes/(dashboard)/dashboard/weight-loss/support/index'
import { Route as dashboardDashboardWeightLossSettingsIndexImport } from './routes/(dashboard)/dashboard/weight-loss/settings/index'
import { Route as dashboardDashboardWeightLossMedicalsIndexImport } from './routes/(dashboard)/dashboard/weight-loss/medicals/index'
import { Route as dashboardDashboardWeightLossAppointmentsIndexImport } from './routes/(dashboard)/dashboard/weight-loss/appointments/index'
import { Route as dashboardDashboardUrgentCareSupportIndexImport } from './routes/(dashboard)/dashboard/urgent-care/support/index'
import { Route as dashboardDashboardUrgentCareSettingsIndexImport } from './routes/(dashboard)/dashboard/urgent-care/settings/index'
import { Route as dashboardDashboardUrgentCareEncountersIndexImport } from './routes/(dashboard)/dashboard/urgent-care/encounters/index'
import { Route as dashboardDashboardUrgentCareAppointmentsIndexImport } from './routes/(dashboard)/dashboard/urgent-care/appointments/index'
import { Route as dashboardDashboardMedicalsProgramIndexImport } from './routes/(dashboard)/dashboard/medicals/$program/index'
import { Route as dashboardDashboardWeightLossMedicalsRefillConfirmationImport } from './routes/(dashboard)/dashboard/weight-loss/medicals/refill-confirmation'
import { Route as dashboardDashboardWeightLossMedicalsErrorImport } from './routes/(dashboard)/dashboard/weight-loss/medicals/error'
import { Route as dashboardDashboardWeightLossMedicalsConfirmationImport } from './routes/(dashboard)/dashboard/weight-loss/medicals/confirmation'
import { Route as dashboardDashboardWeightLossMedicalsTabImport } from './routes/(dashboard)/dashboard/weight-loss/medicals/$tab'
import { Route as dashboardDashboardWeightLossAppointmentsRescheduleBookingImport } from './routes/(dashboard)/dashboard/weight-loss/appointments/reschedule-booking'
import { Route as dashboardDashboardWeightLossAppointmentsErrorImport } from './routes/(dashboard)/dashboard/weight-loss/appointments/error'
import { Route as dashboardDashboardWeightLossAppointmentsConfirmationImport } from './routes/(dashboard)/dashboard/weight-loss/appointments/confirmation'
import { Route as dashboardDashboardWeightLossAppointmentsConfirmRescheduleImport } from './routes/(dashboard)/dashboard/weight-loss/appointments/confirm-reschedule'
import { Route as dashboardDashboardWeightLossAppointmentsBookingImport } from './routes/(dashboard)/dashboard/weight-loss/appointments/booking'
import { Route as dashboardDashboardWeightLossAppointmentsTabImport } from './routes/(dashboard)/dashboard/weight-loss/appointments/$tab'
import { Route as dashboardDashboardUrgentCareAppointmentsBookingImport } from './routes/(dashboard)/dashboard/urgent-care/appointments/booking'
import { Route as dashboardDashboardMedicalsProgramSupportImport } from './routes/(dashboard)/dashboard/medicals/$program/support'
import { Route as dashboardDashboardMedicalsProgramPaymentHistoryImport } from './routes/(dashboard)/dashboard/medicals/$program/payment-history'
import { Route as dashboardDashboardMedicalsProgramConditionsAllergiesImport } from './routes/(dashboard)/dashboard/medicals/$program/conditions-allergies'

// Create Virtual Routes

const publicImport = createFileRoute('/(public)')()

// Create/Update Routes

const publicRoute = publicImport.update({
  id: '/(public)',
  getParentRoute: () => rootRoute,
} as any)

const publicPublicRoute = publicPublicImport.update({
  id: '/_public',
  getParentRoute: () => publicRoute,
} as any)

const dashboardSupplementaryRoute = dashboardSupplementaryImport.update({
  id: '/(dashboard)/supplementary',
  path: '/supplementary',
  getParentRoute: () => rootRoute,
} as any)

const dashboardQuestionnaireRoute = dashboardQuestionnaireImport.update({
  id: '/(dashboard)/questionnaire',
  path: '/questionnaire',
  getParentRoute: () => rootRoute,
} as any)

const dashboardDashboardRoute = dashboardDashboardImport.update({
  id: '/(dashboard)/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRoute,
} as any)

const publicPublicIndexRoute = publicPublicIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => publicPublicRoute,
} as any)

const dashboardDashboardIndexRoute = dashboardDashboardIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => dashboardDashboardRoute,
} as any)

const publicPublicWelcomeRoute = publicPublicWelcomeImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => publicPublicRoute,
} as any)

const publicPublicTermsRoute = publicPublicTermsImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => publicPublicRoute,
} as any)

const publicPublicPrivacyPolicyRoute = publicPublicPrivacyPolicyImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => publicPublicRoute,
} as any)

const publicPublicLiveConsultationRoute =
  publicPublicLiveConsultationImport.update({
    id: '/live-consultation',
    path: '/live-consultation',
    getParentRoute: () => publicPublicRoute,
  } as any)

const publicPublicContactRoute = publicPublicContactImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => publicPublicRoute,
} as any)

const publicPublicConsultationsRoute = publicPublicConsultationsImport.update({
  id: '/consultations',
  path: '/consultations',
  getParentRoute: () => publicPublicRoute,
} as any)

const publicPublicAppointmentsRoute = publicPublicAppointmentsImport.update({
  id: '/appointments',
  path: '/appointments',
  getParentRoute: () => publicPublicRoute,
} as any)

const dashboardDashboardWeightLossRoute =
  dashboardDashboardWeightLossImport.update({
    id: '/weight-loss',
    path: '/weight-loss',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)

const dashboardDashboardUrgentCareRoute =
  dashboardDashboardUrgentCareImport.update({
    id: '/urgent-care',
    path: '/urgent-care',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)

const dashboardDashboardSupplementaryRoute =
  dashboardDashboardSupplementaryImport.update({
    id: '/supplementary',
    path: '/supplementary',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)

const dashboardDashboardSettingsRoute = dashboardDashboardSettingsImport.update(
  {
    id: '/settings',
    path: '/settings',
    getParentRoute: () => dashboardDashboardRoute,
  } as any,
)

const dashboardDashboardOnboardingRoute =
  dashboardDashboardOnboardingImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)

const dashboardDashboardMedicalsRoute = dashboardDashboardMedicalsImport.update(
  {
    id: '/medicals',
    path: '/medicals',
    getParentRoute: () => dashboardDashboardRoute,
  } as any,
)

const publicPublicConsultationsIndexRoute =
  publicPublicConsultationsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => publicPublicConsultationsRoute,
  } as any)

const publicPublicAppointmentsIndexRoute =
  publicPublicAppointmentsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => publicPublicAppointmentsRoute,
  } as any)

const dashboardDashboardWeightLossIndexRoute =
  dashboardDashboardWeightLossIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardWeightLossRoute,
  } as any)

const dashboardDashboardUrgentCareIndexRoute =
  dashboardDashboardUrgentCareIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardUrgentCareRoute,
  } as any)

const dashboardDashboardSupportIndexRoute =
  dashboardDashboardSupportIndexImport.update({
    id: '/support/',
    path: '/support/',
    getParentRoute: () => dashboardDashboardRoute,
  } as any)

const dashboardDashboardSettingsIndexRoute =
  dashboardDashboardSettingsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardSettingsRoute,
  } as any)

const dashboardDashboardOnboardingIndexRoute =
  dashboardDashboardOnboardingIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardOnboardingRoute,
  } as any)

const dashboardDashboardMedicalsIndexRoute =
  dashboardDashboardMedicalsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardMedicalsRoute,
  } as any)

const publicPublicConsultationsErrorRoute =
  publicPublicConsultationsErrorImport.update({
    id: '/error',
    path: '/error',
    getParentRoute: () => publicPublicConsultationsRoute,
  } as any)

const publicPublicConsultationsConfirmationRoute =
  publicPublicConsultationsConfirmationImport.update({
    id: '/confirmation',
    path: '/confirmation',
    getParentRoute: () => publicPublicConsultationsRoute,
  } as any)

const publicPublicAppointmentsErrorRoute =
  publicPublicAppointmentsErrorImport.update({
    id: '/error',
    path: '/error',
    getParentRoute: () => publicPublicAppointmentsRoute,
  } as any)

const publicPublicAppointmentsConfirmationRoute =
  publicPublicAppointmentsConfirmationImport.update({
    id: '/confirmation',
    path: '/confirmation',
    getParentRoute: () => publicPublicAppointmentsRoute,
  } as any)

const dashboardDashboardWeightLossMedicalsRoute =
  dashboardDashboardWeightLossMedicalsImport.update({
    id: '/medicals',
    path: '/medicals',
    getParentRoute: () => dashboardDashboardWeightLossRoute,
  } as any)

const dashboardDashboardWeightLossAppointmentsRoute =
  dashboardDashboardWeightLossAppointmentsImport.update({
    id: '/appointments',
    path: '/appointments',
    getParentRoute: () => dashboardDashboardWeightLossRoute,
  } as any)

const dashboardDashboardMedicalsProgramRouteRoute =
  dashboardDashboardMedicalsProgramRouteImport.update({
    id: '/$program',
    path: '/$program',
    getParentRoute: () => dashboardDashboardMedicalsRoute,
  } as any)

const dashboardDashboardWeightLossSupportIndexRoute =
  dashboardDashboardWeightLossSupportIndexImport.update({
    id: '/support/',
    path: '/support/',
    getParentRoute: () => dashboardDashboardWeightLossRoute,
  } as any)

const dashboardDashboardWeightLossSettingsIndexRoute =
  dashboardDashboardWeightLossSettingsIndexImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => dashboardDashboardWeightLossRoute,
  } as any)

const dashboardDashboardWeightLossMedicalsIndexRoute =
  dashboardDashboardWeightLossMedicalsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardWeightLossMedicalsRoute,
  } as any)

const dashboardDashboardWeightLossAppointmentsIndexRoute =
  dashboardDashboardWeightLossAppointmentsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardWeightLossAppointmentsRoute,
  } as any)

const dashboardDashboardUrgentCareSupportIndexRoute =
  dashboardDashboardUrgentCareSupportIndexImport.update({
    id: '/support/',
    path: '/support/',
    getParentRoute: () => dashboardDashboardUrgentCareRoute,
  } as any)

const dashboardDashboardUrgentCareSettingsIndexRoute =
  dashboardDashboardUrgentCareSettingsIndexImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => dashboardDashboardUrgentCareRoute,
  } as any)

const dashboardDashboardUrgentCareEncountersIndexRoute =
  dashboardDashboardUrgentCareEncountersIndexImport.update({
    id: '/encounters/',
    path: '/encounters/',
    getParentRoute: () => dashboardDashboardUrgentCareRoute,
  } as any)

const dashboardDashboardUrgentCareAppointmentsIndexRoute =
  dashboardDashboardUrgentCareAppointmentsIndexImport.update({
    id: '/appointments/',
    path: '/appointments/',
    getParentRoute: () => dashboardDashboardUrgentCareRoute,
  } as any)

const dashboardDashboardMedicalsProgramIndexRoute =
  dashboardDashboardMedicalsProgramIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => dashboardDashboardMedicalsProgramRouteRoute,
  } as any)

const dashboardDashboardWeightLossMedicalsRefillConfirmationRoute =
  dashboardDashboardWeightLossMedicalsRefillConfirmationImport.update({
    id: '/refill-confirmation',
    path: '/refill-confirmation',
    getParentRoute: () => dashboardDashboardWeightLossMedicalsRoute,
  } as any)

const dashboardDashboardWeightLossMedicalsErrorRoute =
  dashboardDashboardWeightLossMedicalsErrorImport.update({
    id: '/error',
    path: '/error',
    getParentRoute: () => dashboardDashboardWeightLossMedicalsRoute,
  } as any)

const dashboardDashboardWeightLossMedicalsConfirmationRoute =
  dashboardDashboardWeightLossMedicalsConfirmationImport.update({
    id: '/confirmation',
    path: '/confirmation',
    getParentRoute: () => dashboardDashboardWeightLossMedicalsRoute,
  } as any)

const dashboardDashboardWeightLossMedicalsTabRoute =
  dashboardDashboardWeightLossMedicalsTabImport.update({
    id: '/$tab',
    path: '/$tab',
    getParentRoute: () => dashboardDashboardWeightLossMedicalsRoute,
  } as any)

const dashboardDashboardWeightLossAppointmentsRescheduleBookingRoute =
  dashboardDashboardWeightLossAppointmentsRescheduleBookingImport.update({
    id: '/reschedule-booking',
    path: '/reschedule-booking',
    getParentRoute: () => dashboardDashboardWeightLossAppointmentsRoute,
  } as any)

const dashboardDashboardWeightLossAppointmentsErrorRoute =
  dashboardDashboardWeightLossAppointmentsErrorImport.update({
    id: '/error',
    path: '/error',
    getParentRoute: () => dashboardDashboardWeightLossAppointmentsRoute,
  } as any)

const dashboardDashboardWeightLossAppointmentsConfirmationRoute =
  dashboardDashboardWeightLossAppointmentsConfirmationImport.update({
    id: '/confirmation',
    path: '/confirmation',
    getParentRoute: () => dashboardDashboardWeightLossAppointmentsRoute,
  } as any)

const dashboardDashboardWeightLossAppointmentsConfirmRescheduleRoute =
  dashboardDashboardWeightLossAppointmentsConfirmRescheduleImport.update({
    id: '/confirm-reschedule',
    path: '/confirm-reschedule',
    getParentRoute: () => dashboardDashboardWeightLossAppointmentsRoute,
  } as any)

const dashboardDashboardWeightLossAppointmentsBookingRoute =
  dashboardDashboardWeightLossAppointmentsBookingImport.update({
    id: '/booking',
    path: '/booking',
    getParentRoute: () => dashboardDashboardWeightLossAppointmentsRoute,
  } as any)

const dashboardDashboardWeightLossAppointmentsTabRoute =
  dashboardDashboardWeightLossAppointmentsTabImport.update({
    id: '/$tab',
    path: '/$tab',
    getParentRoute: () => dashboardDashboardWeightLossAppointmentsRoute,
  } as any)

const dashboardDashboardUrgentCareAppointmentsBookingRoute =
  dashboardDashboardUrgentCareAppointmentsBookingImport.update({
    id: '/appointments/booking',
    path: '/appointments/booking',
    getParentRoute: () => dashboardDashboardUrgentCareRoute,
  } as any)

const dashboardDashboardMedicalsProgramSupportRoute =
  dashboardDashboardMedicalsProgramSupportImport.update({
    id: '/support',
    path: '/support',
    getParentRoute: () => dashboardDashboardMedicalsProgramRouteRoute,
  } as any)

const dashboardDashboardMedicalsProgramPaymentHistoryRoute =
  dashboardDashboardMedicalsProgramPaymentHistoryImport.update({
    id: '/payment-history',
    path: '/payment-history',
    getParentRoute: () => dashboardDashboardMedicalsProgramRouteRoute,
  } as any)

const dashboardDashboardMedicalsProgramConditionsAllergiesRoute =
  dashboardDashboardMedicalsProgramConditionsAllergiesImport.update({
    id: '/conditions-allergies',
    path: '/conditions-allergies',
    getParentRoute: () => dashboardDashboardMedicalsProgramRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(dashboard)/dashboard': {
      id: '/(dashboard)/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof dashboardDashboardImport
      parentRoute: typeof rootRoute
    }
    '/(dashboard)/questionnaire': {
      id: '/(dashboard)/questionnaire'
      path: '/questionnaire'
      fullPath: '/questionnaire'
      preLoaderRoute: typeof dashboardQuestionnaireImport
      parentRoute: typeof rootRoute
    }
    '/(dashboard)/supplementary': {
      id: '/(dashboard)/supplementary'
      path: '/supplementary'
      fullPath: '/supplementary'
      preLoaderRoute: typeof dashboardSupplementaryImport
      parentRoute: typeof rootRoute
    }
    '/(public)': {
      id: '/(public)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof publicImport
      parentRoute: typeof rootRoute
    }
    '/(public)/_public': {
      id: '/(public)/_public'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof publicPublicImport
      parentRoute: typeof publicRoute
    }
    '/(dashboard)/dashboard/medicals': {
      id: '/(dashboard)/dashboard/medicals'
      path: '/medicals'
      fullPath: '/dashboard/medicals'
      preLoaderRoute: typeof dashboardDashboardMedicalsImport
      parentRoute: typeof dashboardDashboardImport
    }
    '/(dashboard)/dashboard/onboarding': {
      id: '/(dashboard)/dashboard/onboarding'
      path: '/onboarding'
      fullPath: '/dashboard/onboarding'
      preLoaderRoute: typeof dashboardDashboardOnboardingImport
      parentRoute: typeof dashboardDashboardImport
    }
    '/(dashboard)/dashboard/settings': {
      id: '/(dashboard)/dashboard/settings'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof dashboardDashboardSettingsImport
      parentRoute: typeof dashboardDashboardImport
    }
    '/(dashboard)/dashboard/supplementary': {
      id: '/(dashboard)/dashboard/supplementary'
      path: '/supplementary'
      fullPath: '/dashboard/supplementary'
      preLoaderRoute: typeof dashboardDashboardSupplementaryImport
      parentRoute: typeof dashboardDashboardImport
    }
    '/(dashboard)/dashboard/urgent-care': {
      id: '/(dashboard)/dashboard/urgent-care'
      path: '/urgent-care'
      fullPath: '/dashboard/urgent-care'
      preLoaderRoute: typeof dashboardDashboardUrgentCareImport
      parentRoute: typeof dashboardDashboardImport
    }
    '/(dashboard)/dashboard/weight-loss': {
      id: '/(dashboard)/dashboard/weight-loss'
      path: '/weight-loss'
      fullPath: '/dashboard/weight-loss'
      preLoaderRoute: typeof dashboardDashboardWeightLossImport
      parentRoute: typeof dashboardDashboardImport
    }
    '/(public)/_public/appointments': {
      id: '/(public)/_public/appointments'
      path: '/appointments'
      fullPath: '/appointments'
      preLoaderRoute: typeof publicPublicAppointmentsImport
      parentRoute: typeof publicPublicImport
    }
    '/(public)/_public/consultations': {
      id: '/(public)/_public/consultations'
      path: '/consultations'
      fullPath: '/consultations'
      preLoaderRoute: typeof publicPublicConsultationsImport
      parentRoute: typeof publicPublicImport
    }
    '/(public)/_public/contact': {
      id: '/(public)/_public/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof publicPublicContactImport
      parentRoute: typeof publicPublicImport
    }
    '/(public)/_public/live-consultation': {
      id: '/(public)/_public/live-consultation'
      path: '/live-consultation'
      fullPath: '/live-consultation'
      preLoaderRoute: typeof publicPublicLiveConsultationImport
      parentRoute: typeof publicPublicImport
    }
    '/(public)/_public/privacy-policy': {
      id: '/(public)/_public/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof publicPublicPrivacyPolicyImport
      parentRoute: typeof publicPublicImport
    }
    '/(public)/_public/terms': {
      id: '/(public)/_public/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof publicPublicTermsImport
      parentRoute: typeof publicPublicImport
    }
    '/(public)/_public/welcome': {
      id: '/(public)/_public/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof publicPublicWelcomeImport
      parentRoute: typeof publicPublicImport
    }
    '/(dashboard)/dashboard/': {
      id: '/(dashboard)/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof dashboardDashboardIndexImport
      parentRoute: typeof dashboardDashboardImport
    }
    '/(public)/_public/': {
      id: '/(public)/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof publicPublicIndexImport
      parentRoute: typeof publicPublicImport
    }
    '/(dashboard)/dashboard/medicals/$program': {
      id: '/(dashboard)/dashboard/medicals/$program'
      path: '/$program'
      fullPath: '/dashboard/medicals/$program'
      preLoaderRoute: typeof dashboardDashboardMedicalsProgramRouteImport
      parentRoute: typeof dashboardDashboardMedicalsImport
    }
    '/(dashboard)/dashboard/weight-loss/appointments': {
      id: '/(dashboard)/dashboard/weight-loss/appointments'
      path: '/appointments'
      fullPath: '/dashboard/weight-loss/appointments'
      preLoaderRoute: typeof dashboardDashboardWeightLossAppointmentsImport
      parentRoute: typeof dashboardDashboardWeightLossImport
    }
    '/(dashboard)/dashboard/weight-loss/medicals': {
      id: '/(dashboard)/dashboard/weight-loss/medicals'
      path: '/medicals'
      fullPath: '/dashboard/weight-loss/medicals'
      preLoaderRoute: typeof dashboardDashboardWeightLossMedicalsImport
      parentRoute: typeof dashboardDashboardWeightLossImport
    }
    '/(public)/_public/appointments/confirmation': {
      id: '/(public)/_public/appointments/confirmation'
      path: '/confirmation'
      fullPath: '/appointments/confirmation'
      preLoaderRoute: typeof publicPublicAppointmentsConfirmationImport
      parentRoute: typeof publicPublicAppointmentsImport
    }
    '/(public)/_public/appointments/error': {
      id: '/(public)/_public/appointments/error'
      path: '/error'
      fullPath: '/appointments/error'
      preLoaderRoute: typeof publicPublicAppointmentsErrorImport
      parentRoute: typeof publicPublicAppointmentsImport
    }
    '/(public)/_public/consultations/confirmation': {
      id: '/(public)/_public/consultations/confirmation'
      path: '/confirmation'
      fullPath: '/consultations/confirmation'
      preLoaderRoute: typeof publicPublicConsultationsConfirmationImport
      parentRoute: typeof publicPublicConsultationsImport
    }
    '/(public)/_public/consultations/error': {
      id: '/(public)/_public/consultations/error'
      path: '/error'
      fullPath: '/consultations/error'
      preLoaderRoute: typeof publicPublicConsultationsErrorImport
      parentRoute: typeof publicPublicConsultationsImport
    }
    '/(dashboard)/dashboard/medicals/': {
      id: '/(dashboard)/dashboard/medicals/'
      path: '/'
      fullPath: '/dashboard/medicals/'
      preLoaderRoute: typeof dashboardDashboardMedicalsIndexImport
      parentRoute: typeof dashboardDashboardMedicalsImport
    }
    '/(dashboard)/dashboard/onboarding/': {
      id: '/(dashboard)/dashboard/onboarding/'
      path: '/'
      fullPath: '/dashboard/onboarding/'
      preLoaderRoute: typeof dashboardDashboardOnboardingIndexImport
      parentRoute: typeof dashboardDashboardOnboardingImport
    }
    '/(dashboard)/dashboard/settings/': {
      id: '/(dashboard)/dashboard/settings/'
      path: '/'
      fullPath: '/dashboard/settings/'
      preLoaderRoute: typeof dashboardDashboardSettingsIndexImport
      parentRoute: typeof dashboardDashboardSettingsImport
    }
    '/(dashboard)/dashboard/support/': {
      id: '/(dashboard)/dashboard/support/'
      path: '/support'
      fullPath: '/dashboard/support'
      preLoaderRoute: typeof dashboardDashboardSupportIndexImport
      parentRoute: typeof dashboardDashboardImport
    }
    '/(dashboard)/dashboard/urgent-care/': {
      id: '/(dashboard)/dashboard/urgent-care/'
      path: '/'
      fullPath: '/dashboard/urgent-care/'
      preLoaderRoute: typeof dashboardDashboardUrgentCareIndexImport
      parentRoute: typeof dashboardDashboardUrgentCareImport
    }
    '/(dashboard)/dashboard/weight-loss/': {
      id: '/(dashboard)/dashboard/weight-loss/'
      path: '/'
      fullPath: '/dashboard/weight-loss/'
      preLoaderRoute: typeof dashboardDashboardWeightLossIndexImport
      parentRoute: typeof dashboardDashboardWeightLossImport
    }
    '/(public)/_public/appointments/': {
      id: '/(public)/_public/appointments/'
      path: '/'
      fullPath: '/appointments/'
      preLoaderRoute: typeof publicPublicAppointmentsIndexImport
      parentRoute: typeof publicPublicAppointmentsImport
    }
    '/(public)/_public/consultations/': {
      id: '/(public)/_public/consultations/'
      path: '/'
      fullPath: '/consultations/'
      preLoaderRoute: typeof publicPublicConsultationsIndexImport
      parentRoute: typeof publicPublicConsultationsImport
    }
    '/(dashboard)/dashboard/medicals/$program/conditions-allergies': {
      id: '/(dashboard)/dashboard/medicals/$program/conditions-allergies'
      path: '/conditions-allergies'
      fullPath: '/dashboard/medicals/$program/conditions-allergies'
      preLoaderRoute: typeof dashboardDashboardMedicalsProgramConditionsAllergiesImport
      parentRoute: typeof dashboardDashboardMedicalsProgramRouteImport
    }
    '/(dashboard)/dashboard/medicals/$program/payment-history': {
      id: '/(dashboard)/dashboard/medicals/$program/payment-history'
      path: '/payment-history'
      fullPath: '/dashboard/medicals/$program/payment-history'
      preLoaderRoute: typeof dashboardDashboardMedicalsProgramPaymentHistoryImport
      parentRoute: typeof dashboardDashboardMedicalsProgramRouteImport
    }
    '/(dashboard)/dashboard/medicals/$program/support': {
      id: '/(dashboard)/dashboard/medicals/$program/support'
      path: '/support'
      fullPath: '/dashboard/medicals/$program/support'
      preLoaderRoute: typeof dashboardDashboardMedicalsProgramSupportImport
      parentRoute: typeof dashboardDashboardMedicalsProgramRouteImport
    }
    '/(dashboard)/dashboard/urgent-care/appointments/booking': {
      id: '/(dashboard)/dashboard/urgent-care/appointments/booking'
      path: '/appointments/booking'
      fullPath: '/dashboard/urgent-care/appointments/booking'
      preLoaderRoute: typeof dashboardDashboardUrgentCareAppointmentsBookingImport
      parentRoute: typeof dashboardDashboardUrgentCareImport
    }
    '/(dashboard)/dashboard/weight-loss/appointments/$tab': {
      id: '/(dashboard)/dashboard/weight-loss/appointments/$tab'
      path: '/$tab'
      fullPath: '/dashboard/weight-loss/appointments/$tab'
      preLoaderRoute: typeof dashboardDashboardWeightLossAppointmentsTabImport
      parentRoute: typeof dashboardDashboardWeightLossAppointmentsImport
    }
    '/(dashboard)/dashboard/weight-loss/appointments/booking': {
      id: '/(dashboard)/dashboard/weight-loss/appointments/booking'
      path: '/booking'
      fullPath: '/dashboard/weight-loss/appointments/booking'
      preLoaderRoute: typeof dashboardDashboardWeightLossAppointmentsBookingImport
      parentRoute: typeof dashboardDashboardWeightLossAppointmentsImport
    }
    '/(dashboard)/dashboard/weight-loss/appointments/confirm-reschedule': {
      id: '/(dashboard)/dashboard/weight-loss/appointments/confirm-reschedule'
      path: '/confirm-reschedule'
      fullPath: '/dashboard/weight-loss/appointments/confirm-reschedule'
      preLoaderRoute: typeof dashboardDashboardWeightLossAppointmentsConfirmRescheduleImport
      parentRoute: typeof dashboardDashboardWeightLossAppointmentsImport
    }
    '/(dashboard)/dashboard/weight-loss/appointments/confirmation': {
      id: '/(dashboard)/dashboard/weight-loss/appointments/confirmation'
      path: '/confirmation'
      fullPath: '/dashboard/weight-loss/appointments/confirmation'
      preLoaderRoute: typeof dashboardDashboardWeightLossAppointmentsConfirmationImport
      parentRoute: typeof dashboardDashboardWeightLossAppointmentsImport
    }
    '/(dashboard)/dashboard/weight-loss/appointments/error': {
      id: '/(dashboard)/dashboard/weight-loss/appointments/error'
      path: '/error'
      fullPath: '/dashboard/weight-loss/appointments/error'
      preLoaderRoute: typeof dashboardDashboardWeightLossAppointmentsErrorImport
      parentRoute: typeof dashboardDashboardWeightLossAppointmentsImport
    }
    '/(dashboard)/dashboard/weight-loss/appointments/reschedule-booking': {
      id: '/(dashboard)/dashboard/weight-loss/appointments/reschedule-booking'
      path: '/reschedule-booking'
      fullPath: '/dashboard/weight-loss/appointments/reschedule-booking'
      preLoaderRoute: typeof dashboardDashboardWeightLossAppointmentsRescheduleBookingImport
      parentRoute: typeof dashboardDashboardWeightLossAppointmentsImport
    }
    '/(dashboard)/dashboard/weight-loss/medicals/$tab': {
      id: '/(dashboard)/dashboard/weight-loss/medicals/$tab'
      path: '/$tab'
      fullPath: '/dashboard/weight-loss/medicals/$tab'
      preLoaderRoute: typeof dashboardDashboardWeightLossMedicalsTabImport
      parentRoute: typeof dashboardDashboardWeightLossMedicalsImport
    }
    '/(dashboard)/dashboard/weight-loss/medicals/confirmation': {
      id: '/(dashboard)/dashboard/weight-loss/medicals/confirmation'
      path: '/confirmation'
      fullPath: '/dashboard/weight-loss/medicals/confirmation'
      preLoaderRoute: typeof dashboardDashboardWeightLossMedicalsConfirmationImport
      parentRoute: typeof dashboardDashboardWeightLossMedicalsImport
    }
    '/(dashboard)/dashboard/weight-loss/medicals/error': {
      id: '/(dashboard)/dashboard/weight-loss/medicals/error'
      path: '/error'
      fullPath: '/dashboard/weight-loss/medicals/error'
      preLoaderRoute: typeof dashboardDashboardWeightLossMedicalsErrorImport
      parentRoute: typeof dashboardDashboardWeightLossMedicalsImport
    }
    '/(dashboard)/dashboard/weight-loss/medicals/refill-confirmation': {
      id: '/(dashboard)/dashboard/weight-loss/medicals/refill-confirmation'
      path: '/refill-confirmation'
      fullPath: '/dashboard/weight-loss/medicals/refill-confirmation'
      preLoaderRoute: typeof dashboardDashboardWeightLossMedicalsRefillConfirmationImport
      parentRoute: typeof dashboardDashboardWeightLossMedicalsImport
    }
    '/(dashboard)/dashboard/medicals/$program/': {
      id: '/(dashboard)/dashboard/medicals/$program/'
      path: '/'
      fullPath: '/dashboard/medicals/$program/'
      preLoaderRoute: typeof dashboardDashboardMedicalsProgramIndexImport
      parentRoute: typeof dashboardDashboardMedicalsProgramRouteImport
    }
    '/(dashboard)/dashboard/urgent-care/appointments/': {
      id: '/(dashboard)/dashboard/urgent-care/appointments/'
      path: '/appointments'
      fullPath: '/dashboard/urgent-care/appointments'
      preLoaderRoute: typeof dashboardDashboardUrgentCareAppointmentsIndexImport
      parentRoute: typeof dashboardDashboardUrgentCareImport
    }
    '/(dashboard)/dashboard/urgent-care/encounters/': {
      id: '/(dashboard)/dashboard/urgent-care/encounters/'
      path: '/encounters'
      fullPath: '/dashboard/urgent-care/encounters'
      preLoaderRoute: typeof dashboardDashboardUrgentCareEncountersIndexImport
      parentRoute: typeof dashboardDashboardUrgentCareImport
    }
    '/(dashboard)/dashboard/urgent-care/settings/': {
      id: '/(dashboard)/dashboard/urgent-care/settings/'
      path: '/settings'
      fullPath: '/dashboard/urgent-care/settings'
      preLoaderRoute: typeof dashboardDashboardUrgentCareSettingsIndexImport
      parentRoute: typeof dashboardDashboardUrgentCareImport
    }
    '/(dashboard)/dashboard/urgent-care/support/': {
      id: '/(dashboard)/dashboard/urgent-care/support/'
      path: '/support'
      fullPath: '/dashboard/urgent-care/support'
      preLoaderRoute: typeof dashboardDashboardUrgentCareSupportIndexImport
      parentRoute: typeof dashboardDashboardUrgentCareImport
    }
    '/(dashboard)/dashboard/weight-loss/appointments/': {
      id: '/(dashboard)/dashboard/weight-loss/appointments/'
      path: '/'
      fullPath: '/dashboard/weight-loss/appointments/'
      preLoaderRoute: typeof dashboardDashboardWeightLossAppointmentsIndexImport
      parentRoute: typeof dashboardDashboardWeightLossAppointmentsImport
    }
    '/(dashboard)/dashboard/weight-loss/medicals/': {
      id: '/(dashboard)/dashboard/weight-loss/medicals/'
      path: '/'
      fullPath: '/dashboard/weight-loss/medicals/'
      preLoaderRoute: typeof dashboardDashboardWeightLossMedicalsIndexImport
      parentRoute: typeof dashboardDashboardWeightLossMedicalsImport
    }
    '/(dashboard)/dashboard/weight-loss/settings/': {
      id: '/(dashboard)/dashboard/weight-loss/settings/'
      path: '/settings'
      fullPath: '/dashboard/weight-loss/settings'
      preLoaderRoute: typeof dashboardDashboardWeightLossSettingsIndexImport
      parentRoute: typeof dashboardDashboardWeightLossImport
    }
    '/(dashboard)/dashboard/weight-loss/support/': {
      id: '/(dashboard)/dashboard/weight-loss/support/'
      path: '/support'
      fullPath: '/dashboard/weight-loss/support'
      preLoaderRoute: typeof dashboardDashboardWeightLossSupportIndexImport
      parentRoute: typeof dashboardDashboardWeightLossImport
    }
  }
}

// Create and export the route tree

interface dashboardDashboardMedicalsProgramRouteRouteChildren {
  dashboardDashboardMedicalsProgramConditionsAllergiesRoute: typeof dashboardDashboardMedicalsProgramConditionsAllergiesRoute
  dashboardDashboardMedicalsProgramPaymentHistoryRoute: typeof dashboardDashboardMedicalsProgramPaymentHistoryRoute
  dashboardDashboardMedicalsProgramSupportRoute: typeof dashboardDashboardMedicalsProgramSupportRoute
  dashboardDashboardMedicalsProgramIndexRoute: typeof dashboardDashboardMedicalsProgramIndexRoute
}

const dashboardDashboardMedicalsProgramRouteRouteChildren: dashboardDashboardMedicalsProgramRouteRouteChildren =
  {
    dashboardDashboardMedicalsProgramConditionsAllergiesRoute:
      dashboardDashboardMedicalsProgramConditionsAllergiesRoute,
    dashboardDashboardMedicalsProgramPaymentHistoryRoute:
      dashboardDashboardMedicalsProgramPaymentHistoryRoute,
    dashboardDashboardMedicalsProgramSupportRoute:
      dashboardDashboardMedicalsProgramSupportRoute,
    dashboardDashboardMedicalsProgramIndexRoute:
      dashboardDashboardMedicalsProgramIndexRoute,
  }

const dashboardDashboardMedicalsProgramRouteRouteWithChildren =
  dashboardDashboardMedicalsProgramRouteRoute._addFileChildren(
    dashboardDashboardMedicalsProgramRouteRouteChildren,
  )

interface dashboardDashboardMedicalsRouteChildren {
  dashboardDashboardMedicalsProgramRouteRoute: typeof dashboardDashboardMedicalsProgramRouteRouteWithChildren
  dashboardDashboardMedicalsIndexRoute: typeof dashboardDashboardMedicalsIndexRoute
}

const dashboardDashboardMedicalsRouteChildren: dashboardDashboardMedicalsRouteChildren =
  {
    dashboardDashboardMedicalsProgramRouteRoute:
      dashboardDashboardMedicalsProgramRouteRouteWithChildren,
    dashboardDashboardMedicalsIndexRoute: dashboardDashboardMedicalsIndexRoute,
  }

const dashboardDashboardMedicalsRouteWithChildren =
  dashboardDashboardMedicalsRoute._addFileChildren(
    dashboardDashboardMedicalsRouteChildren,
  )

interface dashboardDashboardOnboardingRouteChildren {
  dashboardDashboardOnboardingIndexRoute: typeof dashboardDashboardOnboardingIndexRoute
}

const dashboardDashboardOnboardingRouteChildren: dashboardDashboardOnboardingRouteChildren =
  {
    dashboardDashboardOnboardingIndexRoute:
      dashboardDashboardOnboardingIndexRoute,
  }

const dashboardDashboardOnboardingRouteWithChildren =
  dashboardDashboardOnboardingRoute._addFileChildren(
    dashboardDashboardOnboardingRouteChildren,
  )

interface dashboardDashboardSettingsRouteChildren {
  dashboardDashboardSettingsIndexRoute: typeof dashboardDashboardSettingsIndexRoute
}

const dashboardDashboardSettingsRouteChildren: dashboardDashboardSettingsRouteChildren =
  {
    dashboardDashboardSettingsIndexRoute: dashboardDashboardSettingsIndexRoute,
  }

const dashboardDashboardSettingsRouteWithChildren =
  dashboardDashboardSettingsRoute._addFileChildren(
    dashboardDashboardSettingsRouteChildren,
  )

interface dashboardDashboardUrgentCareRouteChildren {
  dashboardDashboardUrgentCareIndexRoute: typeof dashboardDashboardUrgentCareIndexRoute
  dashboardDashboardUrgentCareAppointmentsBookingRoute: typeof dashboardDashboardUrgentCareAppointmentsBookingRoute
  dashboardDashboardUrgentCareAppointmentsIndexRoute: typeof dashboardDashboardUrgentCareAppointmentsIndexRoute
  dashboardDashboardUrgentCareEncountersIndexRoute: typeof dashboardDashboardUrgentCareEncountersIndexRoute
  dashboardDashboardUrgentCareSettingsIndexRoute: typeof dashboardDashboardUrgentCareSettingsIndexRoute
  dashboardDashboardUrgentCareSupportIndexRoute: typeof dashboardDashboardUrgentCareSupportIndexRoute
}

const dashboardDashboardUrgentCareRouteChildren: dashboardDashboardUrgentCareRouteChildren =
  {
    dashboardDashboardUrgentCareIndexRoute:
      dashboardDashboardUrgentCareIndexRoute,
    dashboardDashboardUrgentCareAppointmentsBookingRoute:
      dashboardDashboardUrgentCareAppointmentsBookingRoute,
    dashboardDashboardUrgentCareAppointmentsIndexRoute:
      dashboardDashboardUrgentCareAppointmentsIndexRoute,
    dashboardDashboardUrgentCareEncountersIndexRoute:
      dashboardDashboardUrgentCareEncountersIndexRoute,
    dashboardDashboardUrgentCareSettingsIndexRoute:
      dashboardDashboardUrgentCareSettingsIndexRoute,
    dashboardDashboardUrgentCareSupportIndexRoute:
      dashboardDashboardUrgentCareSupportIndexRoute,
  }

const dashboardDashboardUrgentCareRouteWithChildren =
  dashboardDashboardUrgentCareRoute._addFileChildren(
    dashboardDashboardUrgentCareRouteChildren,
  )

interface dashboardDashboardWeightLossAppointmentsRouteChildren {
  dashboardDashboardWeightLossAppointmentsTabRoute: typeof dashboardDashboardWeightLossAppointmentsTabRoute
  dashboardDashboardWeightLossAppointmentsBookingRoute: typeof dashboardDashboardWeightLossAppointmentsBookingRoute
  dashboardDashboardWeightLossAppointmentsConfirmRescheduleRoute: typeof dashboardDashboardWeightLossAppointmentsConfirmRescheduleRoute
  dashboardDashboardWeightLossAppointmentsConfirmationRoute: typeof dashboardDashboardWeightLossAppointmentsConfirmationRoute
  dashboardDashboardWeightLossAppointmentsErrorRoute: typeof dashboardDashboardWeightLossAppointmentsErrorRoute
  dashboardDashboardWeightLossAppointmentsRescheduleBookingRoute: typeof dashboardDashboardWeightLossAppointmentsRescheduleBookingRoute
  dashboardDashboardWeightLossAppointmentsIndexRoute: typeof dashboardDashboardWeightLossAppointmentsIndexRoute
}

const dashboardDashboardWeightLossAppointmentsRouteChildren: dashboardDashboardWeightLossAppointmentsRouteChildren =
  {
    dashboardDashboardWeightLossAppointmentsTabRoute:
      dashboardDashboardWeightLossAppointmentsTabRoute,
    dashboardDashboardWeightLossAppointmentsBookingRoute:
      dashboardDashboardWeightLossAppointmentsBookingRoute,
    dashboardDashboardWeightLossAppointmentsConfirmRescheduleRoute:
      dashboardDashboardWeightLossAppointmentsConfirmRescheduleRoute,
    dashboardDashboardWeightLossAppointmentsConfirmationRoute:
      dashboardDashboardWeightLossAppointmentsConfirmationRoute,
    dashboardDashboardWeightLossAppointmentsErrorRoute:
      dashboardDashboardWeightLossAppointmentsErrorRoute,
    dashboardDashboardWeightLossAppointmentsRescheduleBookingRoute:
      dashboardDashboardWeightLossAppointmentsRescheduleBookingRoute,
    dashboardDashboardWeightLossAppointmentsIndexRoute:
      dashboardDashboardWeightLossAppointmentsIndexRoute,
  }

const dashboardDashboardWeightLossAppointmentsRouteWithChildren =
  dashboardDashboardWeightLossAppointmentsRoute._addFileChildren(
    dashboardDashboardWeightLossAppointmentsRouteChildren,
  )

interface dashboardDashboardWeightLossMedicalsRouteChildren {
  dashboardDashboardWeightLossMedicalsTabRoute: typeof dashboardDashboardWeightLossMedicalsTabRoute
  dashboardDashboardWeightLossMedicalsConfirmationRoute: typeof dashboardDashboardWeightLossMedicalsConfirmationRoute
  dashboardDashboardWeightLossMedicalsErrorRoute: typeof dashboardDashboardWeightLossMedicalsErrorRoute
  dashboardDashboardWeightLossMedicalsRefillConfirmationRoute: typeof dashboardDashboardWeightLossMedicalsRefillConfirmationRoute
  dashboardDashboardWeightLossMedicalsIndexRoute: typeof dashboardDashboardWeightLossMedicalsIndexRoute
}

const dashboardDashboardWeightLossMedicalsRouteChildren: dashboardDashboardWeightLossMedicalsRouteChildren =
  {
    dashboardDashboardWeightLossMedicalsTabRoute:
      dashboardDashboardWeightLossMedicalsTabRoute,
    dashboardDashboardWeightLossMedicalsConfirmationRoute:
      dashboardDashboardWeightLossMedicalsConfirmationRoute,
    dashboardDashboardWeightLossMedicalsErrorRoute:
      dashboardDashboardWeightLossMedicalsErrorRoute,
    dashboardDashboardWeightLossMedicalsRefillConfirmationRoute:
      dashboardDashboardWeightLossMedicalsRefillConfirmationRoute,
    dashboardDashboardWeightLossMedicalsIndexRoute:
      dashboardDashboardWeightLossMedicalsIndexRoute,
  }

const dashboardDashboardWeightLossMedicalsRouteWithChildren =
  dashboardDashboardWeightLossMedicalsRoute._addFileChildren(
    dashboardDashboardWeightLossMedicalsRouteChildren,
  )

interface dashboardDashboardWeightLossRouteChildren {
  dashboardDashboardWeightLossAppointmentsRoute: typeof dashboardDashboardWeightLossAppointmentsRouteWithChildren
  dashboardDashboardWeightLossMedicalsRoute: typeof dashboardDashboardWeightLossMedicalsRouteWithChildren
  dashboardDashboardWeightLossIndexRoute: typeof dashboardDashboardWeightLossIndexRoute
  dashboardDashboardWeightLossSettingsIndexRoute: typeof dashboardDashboardWeightLossSettingsIndexRoute
  dashboardDashboardWeightLossSupportIndexRoute: typeof dashboardDashboardWeightLossSupportIndexRoute
}

const dashboardDashboardWeightLossRouteChildren: dashboardDashboardWeightLossRouteChildren =
  {
    dashboardDashboardWeightLossAppointmentsRoute:
      dashboardDashboardWeightLossAppointmentsRouteWithChildren,
    dashboardDashboardWeightLossMedicalsRoute:
      dashboardDashboardWeightLossMedicalsRouteWithChildren,
    dashboardDashboardWeightLossIndexRoute:
      dashboardDashboardWeightLossIndexRoute,
    dashboardDashboardWeightLossSettingsIndexRoute:
      dashboardDashboardWeightLossSettingsIndexRoute,
    dashboardDashboardWeightLossSupportIndexRoute:
      dashboardDashboardWeightLossSupportIndexRoute,
  }

const dashboardDashboardWeightLossRouteWithChildren =
  dashboardDashboardWeightLossRoute._addFileChildren(
    dashboardDashboardWeightLossRouteChildren,
  )

interface dashboardDashboardRouteChildren {
  dashboardDashboardMedicalsRoute: typeof dashboardDashboardMedicalsRouteWithChildren
  dashboardDashboardOnboardingRoute: typeof dashboardDashboardOnboardingRouteWithChildren
  dashboardDashboardSettingsRoute: typeof dashboardDashboardSettingsRouteWithChildren
  dashboardDashboardSupplementaryRoute: typeof dashboardDashboardSupplementaryRoute
  dashboardDashboardUrgentCareRoute: typeof dashboardDashboardUrgentCareRouteWithChildren
  dashboardDashboardWeightLossRoute: typeof dashboardDashboardWeightLossRouteWithChildren
  dashboardDashboardIndexRoute: typeof dashboardDashboardIndexRoute
  dashboardDashboardSupportIndexRoute: typeof dashboardDashboardSupportIndexRoute
}

const dashboardDashboardRouteChildren: dashboardDashboardRouteChildren = {
  dashboardDashboardMedicalsRoute: dashboardDashboardMedicalsRouteWithChildren,
  dashboardDashboardOnboardingRoute:
    dashboardDashboardOnboardingRouteWithChildren,
  dashboardDashboardSettingsRoute: dashboardDashboardSettingsRouteWithChildren,
  dashboardDashboardSupplementaryRoute: dashboardDashboardSupplementaryRoute,
  dashboardDashboardUrgentCareRoute:
    dashboardDashboardUrgentCareRouteWithChildren,
  dashboardDashboardWeightLossRoute:
    dashboardDashboardWeightLossRouteWithChildren,
  dashboardDashboardIndexRoute: dashboardDashboardIndexRoute,
  dashboardDashboardSupportIndexRoute: dashboardDashboardSupportIndexRoute,
}

const dashboardDashboardRouteWithChildren =
  dashboardDashboardRoute._addFileChildren(dashboardDashboardRouteChildren)

interface publicPublicAppointmentsRouteChildren {
  publicPublicAppointmentsConfirmationRoute: typeof publicPublicAppointmentsConfirmationRoute
  publicPublicAppointmentsErrorRoute: typeof publicPublicAppointmentsErrorRoute
  publicPublicAppointmentsIndexRoute: typeof publicPublicAppointmentsIndexRoute
}

const publicPublicAppointmentsRouteChildren: publicPublicAppointmentsRouteChildren =
  {
    publicPublicAppointmentsConfirmationRoute:
      publicPublicAppointmentsConfirmationRoute,
    publicPublicAppointmentsErrorRoute: publicPublicAppointmentsErrorRoute,
    publicPublicAppointmentsIndexRoute: publicPublicAppointmentsIndexRoute,
  }

const publicPublicAppointmentsRouteWithChildren =
  publicPublicAppointmentsRoute._addFileChildren(
    publicPublicAppointmentsRouteChildren,
  )

interface publicPublicConsultationsRouteChildren {
  publicPublicConsultationsConfirmationRoute: typeof publicPublicConsultationsConfirmationRoute
  publicPublicConsultationsErrorRoute: typeof publicPublicConsultationsErrorRoute
  publicPublicConsultationsIndexRoute: typeof publicPublicConsultationsIndexRoute
}

const publicPublicConsultationsRouteChildren: publicPublicConsultationsRouteChildren =
  {
    publicPublicConsultationsConfirmationRoute:
      publicPublicConsultationsConfirmationRoute,
    publicPublicConsultationsErrorRoute: publicPublicConsultationsErrorRoute,
    publicPublicConsultationsIndexRoute: publicPublicConsultationsIndexRoute,
  }

const publicPublicConsultationsRouteWithChildren =
  publicPublicConsultationsRoute._addFileChildren(
    publicPublicConsultationsRouteChildren,
  )

interface publicPublicRouteChildren {
  publicPublicAppointmentsRoute: typeof publicPublicAppointmentsRouteWithChildren
  publicPublicConsultationsRoute: typeof publicPublicConsultationsRouteWithChildren
  publicPublicContactRoute: typeof publicPublicContactRoute
  publicPublicLiveConsultationRoute: typeof publicPublicLiveConsultationRoute
  publicPublicPrivacyPolicyRoute: typeof publicPublicPrivacyPolicyRoute
  publicPublicTermsRoute: typeof publicPublicTermsRoute
  publicPublicWelcomeRoute: typeof publicPublicWelcomeRoute
  publicPublicIndexRoute: typeof publicPublicIndexRoute
}

const publicPublicRouteChildren: publicPublicRouteChildren = {
  publicPublicAppointmentsRoute: publicPublicAppointmentsRouteWithChildren,
  publicPublicConsultationsRoute: publicPublicConsultationsRouteWithChildren,
  publicPublicContactRoute: publicPublicContactRoute,
  publicPublicLiveConsultationRoute: publicPublicLiveConsultationRoute,
  publicPublicPrivacyPolicyRoute: publicPublicPrivacyPolicyRoute,
  publicPublicTermsRoute: publicPublicTermsRoute,
  publicPublicWelcomeRoute: publicPublicWelcomeRoute,
  publicPublicIndexRoute: publicPublicIndexRoute,
}

const publicPublicRouteWithChildren = publicPublicRoute._addFileChildren(
  publicPublicRouteChildren,
)

interface publicRouteChildren {
  publicPublicRoute: typeof publicPublicRouteWithChildren
}

const publicRouteChildren: publicRouteChildren = {
  publicPublicRoute: publicPublicRouteWithChildren,
}

const publicRouteWithChildren =
  publicRoute._addFileChildren(publicRouteChildren)

export interface FileRoutesByFullPath {
  '/dashboard': typeof dashboardDashboardRouteWithChildren
  '/questionnaire': typeof dashboardQuestionnaireRoute
  '/supplementary': typeof dashboardSupplementaryRoute
  '/': typeof publicPublicIndexRoute
  '/dashboard/medicals': typeof dashboardDashboardMedicalsRouteWithChildren
  '/dashboard/onboarding': typeof dashboardDashboardOnboardingRouteWithChildren
  '/dashboard/settings': typeof dashboardDashboardSettingsRouteWithChildren
  '/dashboard/supplementary': typeof dashboardDashboardSupplementaryRoute
  '/dashboard/urgent-care': typeof dashboardDashboardUrgentCareRouteWithChildren
  '/dashboard/weight-loss': typeof dashboardDashboardWeightLossRouteWithChildren
  '/appointments': typeof publicPublicAppointmentsRouteWithChildren
  '/consultations': typeof publicPublicConsultationsRouteWithChildren
  '/contact': typeof publicPublicContactRoute
  '/live-consultation': typeof publicPublicLiveConsultationRoute
  '/privacy-policy': typeof publicPublicPrivacyPolicyRoute
  '/terms': typeof publicPublicTermsRoute
  '/welcome': typeof publicPublicWelcomeRoute
  '/dashboard/': typeof dashboardDashboardIndexRoute
  '/dashboard/medicals/$program': typeof dashboardDashboardMedicalsProgramRouteRouteWithChildren
  '/dashboard/weight-loss/appointments': typeof dashboardDashboardWeightLossAppointmentsRouteWithChildren
  '/dashboard/weight-loss/medicals': typeof dashboardDashboardWeightLossMedicalsRouteWithChildren
  '/appointments/confirmation': typeof publicPublicAppointmentsConfirmationRoute
  '/appointments/error': typeof publicPublicAppointmentsErrorRoute
  '/consultations/confirmation': typeof publicPublicConsultationsConfirmationRoute
  '/consultations/error': typeof publicPublicConsultationsErrorRoute
  '/dashboard/medicals/': typeof dashboardDashboardMedicalsIndexRoute
  '/dashboard/onboarding/': typeof dashboardDashboardOnboardingIndexRoute
  '/dashboard/settings/': typeof dashboardDashboardSettingsIndexRoute
  '/dashboard/support': typeof dashboardDashboardSupportIndexRoute
  '/dashboard/urgent-care/': typeof dashboardDashboardUrgentCareIndexRoute
  '/dashboard/weight-loss/': typeof dashboardDashboardWeightLossIndexRoute
  '/appointments/': typeof publicPublicAppointmentsIndexRoute
  '/consultations/': typeof publicPublicConsultationsIndexRoute
  '/dashboard/medicals/$program/conditions-allergies': typeof dashboardDashboardMedicalsProgramConditionsAllergiesRoute
  '/dashboard/medicals/$program/payment-history': typeof dashboardDashboardMedicalsProgramPaymentHistoryRoute
  '/dashboard/medicals/$program/support': typeof dashboardDashboardMedicalsProgramSupportRoute
  '/dashboard/urgent-care/appointments/booking': typeof dashboardDashboardUrgentCareAppointmentsBookingRoute
  '/dashboard/weight-loss/appointments/$tab': typeof dashboardDashboardWeightLossAppointmentsTabRoute
  '/dashboard/weight-loss/appointments/booking': typeof dashboardDashboardWeightLossAppointmentsBookingRoute
  '/dashboard/weight-loss/appointments/confirm-reschedule': typeof dashboardDashboardWeightLossAppointmentsConfirmRescheduleRoute
  '/dashboard/weight-loss/appointments/confirmation': typeof dashboardDashboardWeightLossAppointmentsConfirmationRoute
  '/dashboard/weight-loss/appointments/error': typeof dashboardDashboardWeightLossAppointmentsErrorRoute
  '/dashboard/weight-loss/appointments/reschedule-booking': typeof dashboardDashboardWeightLossAppointmentsRescheduleBookingRoute
  '/dashboard/weight-loss/medicals/$tab': typeof dashboardDashboardWeightLossMedicalsTabRoute
  '/dashboard/weight-loss/medicals/confirmation': typeof dashboardDashboardWeightLossMedicalsConfirmationRoute
  '/dashboard/weight-loss/medicals/error': typeof dashboardDashboardWeightLossMedicalsErrorRoute
  '/dashboard/weight-loss/medicals/refill-confirmation': typeof dashboardDashboardWeightLossMedicalsRefillConfirmationRoute
  '/dashboard/medicals/$program/': typeof dashboardDashboardMedicalsProgramIndexRoute
  '/dashboard/urgent-care/appointments': typeof dashboardDashboardUrgentCareAppointmentsIndexRoute
  '/dashboard/urgent-care/encounters': typeof dashboardDashboardUrgentCareEncountersIndexRoute
  '/dashboard/urgent-care/settings': typeof dashboardDashboardUrgentCareSettingsIndexRoute
  '/dashboard/urgent-care/support': typeof dashboardDashboardUrgentCareSupportIndexRoute
  '/dashboard/weight-loss/appointments/': typeof dashboardDashboardWeightLossAppointmentsIndexRoute
  '/dashboard/weight-loss/medicals/': typeof dashboardDashboardWeightLossMedicalsIndexRoute
  '/dashboard/weight-loss/settings': typeof dashboardDashboardWeightLossSettingsIndexRoute
  '/dashboard/weight-loss/support': typeof dashboardDashboardWeightLossSupportIndexRoute
}

export interface FileRoutesByTo {
  '/questionnaire': typeof dashboardQuestionnaireRoute
  '/supplementary': typeof dashboardSupplementaryRoute
  '/dashboard/supplementary': typeof dashboardDashboardSupplementaryRoute
  '/contact': typeof publicPublicContactRoute
  '/live-consultation': typeof publicPublicLiveConsultationRoute
  '/privacy-policy': typeof publicPublicPrivacyPolicyRoute
  '/terms': typeof publicPublicTermsRoute
  '/welcome': typeof publicPublicWelcomeRoute
  '/dashboard': typeof dashboardDashboardIndexRoute
  '/': typeof publicPublicIndexRoute
  '/appointments/confirmation': typeof publicPublicAppointmentsConfirmationRoute
  '/appointments/error': typeof publicPublicAppointmentsErrorRoute
  '/consultations/confirmation': typeof publicPublicConsultationsConfirmationRoute
  '/consultations/error': typeof publicPublicConsultationsErrorRoute
  '/dashboard/medicals': typeof dashboardDashboardMedicalsIndexRoute
  '/dashboard/onboarding': typeof dashboardDashboardOnboardingIndexRoute
  '/dashboard/settings': typeof dashboardDashboardSettingsIndexRoute
  '/dashboard/support': typeof dashboardDashboardSupportIndexRoute
  '/dashboard/urgent-care': typeof dashboardDashboardUrgentCareIndexRoute
  '/dashboard/weight-loss': typeof dashboardDashboardWeightLossIndexRoute
  '/appointments': typeof publicPublicAppointmentsIndexRoute
  '/consultations': typeof publicPublicConsultationsIndexRoute
  '/dashboard/medicals/$program/conditions-allergies': typeof dashboardDashboardMedicalsProgramConditionsAllergiesRoute
  '/dashboard/medicals/$program/payment-history': typeof dashboardDashboardMedicalsProgramPaymentHistoryRoute
  '/dashboard/medicals/$program/support': typeof dashboardDashboardMedicalsProgramSupportRoute
  '/dashboard/urgent-care/appointments/booking': typeof dashboardDashboardUrgentCareAppointmentsBookingRoute
  '/dashboard/weight-loss/appointments/$tab': typeof dashboardDashboardWeightLossAppointmentsTabRoute
  '/dashboard/weight-loss/appointments/booking': typeof dashboardDashboardWeightLossAppointmentsBookingRoute
  '/dashboard/weight-loss/appointments/confirm-reschedule': typeof dashboardDashboardWeightLossAppointmentsConfirmRescheduleRoute
  '/dashboard/weight-loss/appointments/confirmation': typeof dashboardDashboardWeightLossAppointmentsConfirmationRoute
  '/dashboard/weight-loss/appointments/error': typeof dashboardDashboardWeightLossAppointmentsErrorRoute
  '/dashboard/weight-loss/appointments/reschedule-booking': typeof dashboardDashboardWeightLossAppointmentsRescheduleBookingRoute
  '/dashboard/weight-loss/medicals/$tab': typeof dashboardDashboardWeightLossMedicalsTabRoute
  '/dashboard/weight-loss/medicals/confirmation': typeof dashboardDashboardWeightLossMedicalsConfirmationRoute
  '/dashboard/weight-loss/medicals/error': typeof dashboardDashboardWeightLossMedicalsErrorRoute
  '/dashboard/weight-loss/medicals/refill-confirmation': typeof dashboardDashboardWeightLossMedicalsRefillConfirmationRoute
  '/dashboard/medicals/$program': typeof dashboardDashboardMedicalsProgramIndexRoute
  '/dashboard/urgent-care/appointments': typeof dashboardDashboardUrgentCareAppointmentsIndexRoute
  '/dashboard/urgent-care/encounters': typeof dashboardDashboardUrgentCareEncountersIndexRoute
  '/dashboard/urgent-care/settings': typeof dashboardDashboardUrgentCareSettingsIndexRoute
  '/dashboard/urgent-care/support': typeof dashboardDashboardUrgentCareSupportIndexRoute
  '/dashboard/weight-loss/appointments': typeof dashboardDashboardWeightLossAppointmentsIndexRoute
  '/dashboard/weight-loss/medicals': typeof dashboardDashboardWeightLossMedicalsIndexRoute
  '/dashboard/weight-loss/settings': typeof dashboardDashboardWeightLossSettingsIndexRoute
  '/dashboard/weight-loss/support': typeof dashboardDashboardWeightLossSupportIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/(dashboard)/dashboard': typeof dashboardDashboardRouteWithChildren
  '/(dashboard)/questionnaire': typeof dashboardQuestionnaireRoute
  '/(dashboard)/supplementary': typeof dashboardSupplementaryRoute
  '/(public)': typeof publicRouteWithChildren
  '/(public)/_public': typeof publicPublicRouteWithChildren
  '/(dashboard)/dashboard/medicals': typeof dashboardDashboardMedicalsRouteWithChildren
  '/(dashboard)/dashboard/onboarding': typeof dashboardDashboardOnboardingRouteWithChildren
  '/(dashboard)/dashboard/settings': typeof dashboardDashboardSettingsRouteWithChildren
  '/(dashboard)/dashboard/supplementary': typeof dashboardDashboardSupplementaryRoute
  '/(dashboard)/dashboard/urgent-care': typeof dashboardDashboardUrgentCareRouteWithChildren
  '/(dashboard)/dashboard/weight-loss': typeof dashboardDashboardWeightLossRouteWithChildren
  '/(public)/_public/appointments': typeof publicPublicAppointmentsRouteWithChildren
  '/(public)/_public/consultations': typeof publicPublicConsultationsRouteWithChildren
  '/(public)/_public/contact': typeof publicPublicContactRoute
  '/(public)/_public/live-consultation': typeof publicPublicLiveConsultationRoute
  '/(public)/_public/privacy-policy': typeof publicPublicPrivacyPolicyRoute
  '/(public)/_public/terms': typeof publicPublicTermsRoute
  '/(public)/_public/welcome': typeof publicPublicWelcomeRoute
  '/(dashboard)/dashboard/': typeof dashboardDashboardIndexRoute
  '/(public)/_public/': typeof publicPublicIndexRoute
  '/(dashboard)/dashboard/medicals/$program': typeof dashboardDashboardMedicalsProgramRouteRouteWithChildren
  '/(dashboard)/dashboard/weight-loss/appointments': typeof dashboardDashboardWeightLossAppointmentsRouteWithChildren
  '/(dashboard)/dashboard/weight-loss/medicals': typeof dashboardDashboardWeightLossMedicalsRouteWithChildren
  '/(public)/_public/appointments/confirmation': typeof publicPublicAppointmentsConfirmationRoute
  '/(public)/_public/appointments/error': typeof publicPublicAppointmentsErrorRoute
  '/(public)/_public/consultations/confirmation': typeof publicPublicConsultationsConfirmationRoute
  '/(public)/_public/consultations/error': typeof publicPublicConsultationsErrorRoute
  '/(dashboard)/dashboard/medicals/': typeof dashboardDashboardMedicalsIndexRoute
  '/(dashboard)/dashboard/onboarding/': typeof dashboardDashboardOnboardingIndexRoute
  '/(dashboard)/dashboard/settings/': typeof dashboardDashboardSettingsIndexRoute
  '/(dashboard)/dashboard/support/': typeof dashboardDashboardSupportIndexRoute
  '/(dashboard)/dashboard/urgent-care/': typeof dashboardDashboardUrgentCareIndexRoute
  '/(dashboard)/dashboard/weight-loss/': typeof dashboardDashboardWeightLossIndexRoute
  '/(public)/_public/appointments/': typeof publicPublicAppointmentsIndexRoute
  '/(public)/_public/consultations/': typeof publicPublicConsultationsIndexRoute
  '/(dashboard)/dashboard/medicals/$program/conditions-allergies': typeof dashboardDashboardMedicalsProgramConditionsAllergiesRoute
  '/(dashboard)/dashboard/medicals/$program/payment-history': typeof dashboardDashboardMedicalsProgramPaymentHistoryRoute
  '/(dashboard)/dashboard/medicals/$program/support': typeof dashboardDashboardMedicalsProgramSupportRoute
  '/(dashboard)/dashboard/urgent-care/appointments/booking': typeof dashboardDashboardUrgentCareAppointmentsBookingRoute
  '/(dashboard)/dashboard/weight-loss/appointments/$tab': typeof dashboardDashboardWeightLossAppointmentsTabRoute
  '/(dashboard)/dashboard/weight-loss/appointments/booking': typeof dashboardDashboardWeightLossAppointmentsBookingRoute
  '/(dashboard)/dashboard/weight-loss/appointments/confirm-reschedule': typeof dashboardDashboardWeightLossAppointmentsConfirmRescheduleRoute
  '/(dashboard)/dashboard/weight-loss/appointments/confirmation': typeof dashboardDashboardWeightLossAppointmentsConfirmationRoute
  '/(dashboard)/dashboard/weight-loss/appointments/error': typeof dashboardDashboardWeightLossAppointmentsErrorRoute
  '/(dashboard)/dashboard/weight-loss/appointments/reschedule-booking': typeof dashboardDashboardWeightLossAppointmentsRescheduleBookingRoute
  '/(dashboard)/dashboard/weight-loss/medicals/$tab': typeof dashboardDashboardWeightLossMedicalsTabRoute
  '/(dashboard)/dashboard/weight-loss/medicals/confirmation': typeof dashboardDashboardWeightLossMedicalsConfirmationRoute
  '/(dashboard)/dashboard/weight-loss/medicals/error': typeof dashboardDashboardWeightLossMedicalsErrorRoute
  '/(dashboard)/dashboard/weight-loss/medicals/refill-confirmation': typeof dashboardDashboardWeightLossMedicalsRefillConfirmationRoute
  '/(dashboard)/dashboard/medicals/$program/': typeof dashboardDashboardMedicalsProgramIndexRoute
  '/(dashboard)/dashboard/urgent-care/appointments/': typeof dashboardDashboardUrgentCareAppointmentsIndexRoute
  '/(dashboard)/dashboard/urgent-care/encounters/': typeof dashboardDashboardUrgentCareEncountersIndexRoute
  '/(dashboard)/dashboard/urgent-care/settings/': typeof dashboardDashboardUrgentCareSettingsIndexRoute
  '/(dashboard)/dashboard/urgent-care/support/': typeof dashboardDashboardUrgentCareSupportIndexRoute
  '/(dashboard)/dashboard/weight-loss/appointments/': typeof dashboardDashboardWeightLossAppointmentsIndexRoute
  '/(dashboard)/dashboard/weight-loss/medicals/': typeof dashboardDashboardWeightLossMedicalsIndexRoute
  '/(dashboard)/dashboard/weight-loss/settings/': typeof dashboardDashboardWeightLossSettingsIndexRoute
  '/(dashboard)/dashboard/weight-loss/support/': typeof dashboardDashboardWeightLossSupportIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/dashboard'
    | '/questionnaire'
    | '/supplementary'
    | '/'
    | '/dashboard/medicals'
    | '/dashboard/onboarding'
    | '/dashboard/settings'
    | '/dashboard/supplementary'
    | '/dashboard/urgent-care'
    | '/dashboard/weight-loss'
    | '/appointments'
    | '/consultations'
    | '/contact'
    | '/live-consultation'
    | '/privacy-policy'
    | '/terms'
    | '/welcome'
    | '/dashboard/'
    | '/dashboard/medicals/$program'
    | '/dashboard/weight-loss/appointments'
    | '/dashboard/weight-loss/medicals'
    | '/appointments/confirmation'
    | '/appointments/error'
    | '/consultations/confirmation'
    | '/consultations/error'
    | '/dashboard/medicals/'
    | '/dashboard/onboarding/'
    | '/dashboard/settings/'
    | '/dashboard/support'
    | '/dashboard/urgent-care/'
    | '/dashboard/weight-loss/'
    | '/appointments/'
    | '/consultations/'
    | '/dashboard/medicals/$program/conditions-allergies'
    | '/dashboard/medicals/$program/payment-history'
    | '/dashboard/medicals/$program/support'
    | '/dashboard/urgent-care/appointments/booking'
    | '/dashboard/weight-loss/appointments/$tab'
    | '/dashboard/weight-loss/appointments/booking'
    | '/dashboard/weight-loss/appointments/confirm-reschedule'
    | '/dashboard/weight-loss/appointments/confirmation'
    | '/dashboard/weight-loss/appointments/error'
    | '/dashboard/weight-loss/appointments/reschedule-booking'
    | '/dashboard/weight-loss/medicals/$tab'
    | '/dashboard/weight-loss/medicals/confirmation'
    | '/dashboard/weight-loss/medicals/error'
    | '/dashboard/weight-loss/medicals/refill-confirmation'
    | '/dashboard/medicals/$program/'
    | '/dashboard/urgent-care/appointments'
    | '/dashboard/urgent-care/encounters'
    | '/dashboard/urgent-care/settings'
    | '/dashboard/urgent-care/support'
    | '/dashboard/weight-loss/appointments/'
    | '/dashboard/weight-loss/medicals/'
    | '/dashboard/weight-loss/settings'
    | '/dashboard/weight-loss/support'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/questionnaire'
    | '/supplementary'
    | '/dashboard/supplementary'
    | '/contact'
    | '/live-consultation'
    | '/privacy-policy'
    | '/terms'
    | '/welcome'
    | '/dashboard'
    | '/'
    | '/appointments/confirmation'
    | '/appointments/error'
    | '/consultations/confirmation'
    | '/consultations/error'
    | '/dashboard/medicals'
    | '/dashboard/onboarding'
    | '/dashboard/settings'
    | '/dashboard/support'
    | '/dashboard/urgent-care'
    | '/dashboard/weight-loss'
    | '/appointments'
    | '/consultations'
    | '/dashboard/medicals/$program/conditions-allergies'
    | '/dashboard/medicals/$program/payment-history'
    | '/dashboard/medicals/$program/support'
    | '/dashboard/urgent-care/appointments/booking'
    | '/dashboard/weight-loss/appointments/$tab'
    | '/dashboard/weight-loss/appointments/booking'
    | '/dashboard/weight-loss/appointments/confirm-reschedule'
    | '/dashboard/weight-loss/appointments/confirmation'
    | '/dashboard/weight-loss/appointments/error'
    | '/dashboard/weight-loss/appointments/reschedule-booking'
    | '/dashboard/weight-loss/medicals/$tab'
    | '/dashboard/weight-loss/medicals/confirmation'
    | '/dashboard/weight-loss/medicals/error'
    | '/dashboard/weight-loss/medicals/refill-confirmation'
    | '/dashboard/medicals/$program'
    | '/dashboard/urgent-care/appointments'
    | '/dashboard/urgent-care/encounters'
    | '/dashboard/urgent-care/settings'
    | '/dashboard/urgent-care/support'
    | '/dashboard/weight-loss/appointments'
    | '/dashboard/weight-loss/medicals'
    | '/dashboard/weight-loss/settings'
    | '/dashboard/weight-loss/support'
  id:
    | '__root__'
    | '/(dashboard)/dashboard'
    | '/(dashboard)/questionnaire'
    | '/(dashboard)/supplementary'
    | '/(public)'
    | '/(public)/_public'
    | '/(dashboard)/dashboard/medicals'
    | '/(dashboard)/dashboard/onboarding'
    | '/(dashboard)/dashboard/settings'
    | '/(dashboard)/dashboard/supplementary'
    | '/(dashboard)/dashboard/urgent-care'
    | '/(dashboard)/dashboard/weight-loss'
    | '/(public)/_public/appointments'
    | '/(public)/_public/consultations'
    | '/(public)/_public/contact'
    | '/(public)/_public/live-consultation'
    | '/(public)/_public/privacy-policy'
    | '/(public)/_public/terms'
    | '/(public)/_public/welcome'
    | '/(dashboard)/dashboard/'
    | '/(public)/_public/'
    | '/(dashboard)/dashboard/medicals/$program'
    | '/(dashboard)/dashboard/weight-loss/appointments'
    | '/(dashboard)/dashboard/weight-loss/medicals'
    | '/(public)/_public/appointments/confirmation'
    | '/(public)/_public/appointments/error'
    | '/(public)/_public/consultations/confirmation'
    | '/(public)/_public/consultations/error'
    | '/(dashboard)/dashboard/medicals/'
    | '/(dashboard)/dashboard/onboarding/'
    | '/(dashboard)/dashboard/settings/'
    | '/(dashboard)/dashboard/support/'
    | '/(dashboard)/dashboard/urgent-care/'
    | '/(dashboard)/dashboard/weight-loss/'
    | '/(public)/_public/appointments/'
    | '/(public)/_public/consultations/'
    | '/(dashboard)/dashboard/medicals/$program/conditions-allergies'
    | '/(dashboard)/dashboard/medicals/$program/payment-history'
    | '/(dashboard)/dashboard/medicals/$program/support'
    | '/(dashboard)/dashboard/urgent-care/appointments/booking'
    | '/(dashboard)/dashboard/weight-loss/appointments/$tab'
    | '/(dashboard)/dashboard/weight-loss/appointments/booking'
    | '/(dashboard)/dashboard/weight-loss/appointments/confirm-reschedule'
    | '/(dashboard)/dashboard/weight-loss/appointments/confirmation'
    | '/(dashboard)/dashboard/weight-loss/appointments/error'
    | '/(dashboard)/dashboard/weight-loss/appointments/reschedule-booking'
    | '/(dashboard)/dashboard/weight-loss/medicals/$tab'
    | '/(dashboard)/dashboard/weight-loss/medicals/confirmation'
    | '/(dashboard)/dashboard/weight-loss/medicals/error'
    | '/(dashboard)/dashboard/weight-loss/medicals/refill-confirmation'
    | '/(dashboard)/dashboard/medicals/$program/'
    | '/(dashboard)/dashboard/urgent-care/appointments/'
    | '/(dashboard)/dashboard/urgent-care/encounters/'
    | '/(dashboard)/dashboard/urgent-care/settings/'
    | '/(dashboard)/dashboard/urgent-care/support/'
    | '/(dashboard)/dashboard/weight-loss/appointments/'
    | '/(dashboard)/dashboard/weight-loss/medicals/'
    | '/(dashboard)/dashboard/weight-loss/settings/'
    | '/(dashboard)/dashboard/weight-loss/support/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  dashboardDashboardRoute: typeof dashboardDashboardRouteWithChildren
  dashboardQuestionnaireRoute: typeof dashboardQuestionnaireRoute
  dashboardSupplementaryRoute: typeof dashboardSupplementaryRoute
  publicRoute: typeof publicRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  dashboardDashboardRoute: dashboardDashboardRouteWithChildren,
  dashboardQuestionnaireRoute: dashboardQuestionnaireRoute,
  dashboardSupplementaryRoute: dashboardSupplementaryRoute,
  publicRoute: publicRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/(dashboard)/dashboard",
        "/(dashboard)/questionnaire",
        "/(dashboard)/supplementary",
        "/(public)"
      ]
    },
    "/(dashboard)/dashboard": {
      "filePath": "(dashboard)/dashboard.tsx",
      "children": [
        "/(dashboard)/dashboard/medicals",
        "/(dashboard)/dashboard/onboarding",
        "/(dashboard)/dashboard/settings",
        "/(dashboard)/dashboard/supplementary",
        "/(dashboard)/dashboard/urgent-care",
        "/(dashboard)/dashboard/weight-loss",
        "/(dashboard)/dashboard/",
        "/(dashboard)/dashboard/support/"
      ]
    },
    "/(dashboard)/questionnaire": {
      "filePath": "(dashboard)/questionnaire.tsx"
    },
    "/(dashboard)/supplementary": {
      "filePath": "(dashboard)/supplementary.tsx"
    },
    "/(public)": {
      "filePath": "(public)",
      "children": [
        "/(public)/_public"
      ]
    },
    "/(public)/_public": {
      "filePath": "(public)/_public.tsx",
      "parent": "/(public)",
      "children": [
        "/(public)/_public/appointments",
        "/(public)/_public/consultations",
        "/(public)/_public/contact",
        "/(public)/_public/live-consultation",
        "/(public)/_public/privacy-policy",
        "/(public)/_public/terms",
        "/(public)/_public/welcome",
        "/(public)/_public/"
      ]
    },
    "/(dashboard)/dashboard/medicals": {
      "filePath": "(dashboard)/dashboard/medicals.tsx",
      "parent": "/(dashboard)/dashboard",
      "children": [
        "/(dashboard)/dashboard/medicals/$program",
        "/(dashboard)/dashboard/medicals/"
      ]
    },
    "/(dashboard)/dashboard/onboarding": {
      "filePath": "(dashboard)/dashboard/onboarding.tsx",
      "parent": "/(dashboard)/dashboard",
      "children": [
        "/(dashboard)/dashboard/onboarding/"
      ]
    },
    "/(dashboard)/dashboard/settings": {
      "filePath": "(dashboard)/dashboard/settings.tsx",
      "parent": "/(dashboard)/dashboard",
      "children": [
        "/(dashboard)/dashboard/settings/"
      ]
    },
    "/(dashboard)/dashboard/supplementary": {
      "filePath": "(dashboard)/dashboard/supplementary.tsx",
      "parent": "/(dashboard)/dashboard"
    },
    "/(dashboard)/dashboard/urgent-care": {
      "filePath": "(dashboard)/dashboard/urgent-care.tsx",
      "parent": "/(dashboard)/dashboard",
      "children": [
        "/(dashboard)/dashboard/urgent-care/",
        "/(dashboard)/dashboard/urgent-care/appointments/booking",
        "/(dashboard)/dashboard/urgent-care/appointments/",
        "/(dashboard)/dashboard/urgent-care/encounters/",
        "/(dashboard)/dashboard/urgent-care/settings/",
        "/(dashboard)/dashboard/urgent-care/support/"
      ]
    },
    "/(dashboard)/dashboard/weight-loss": {
      "filePath": "(dashboard)/dashboard/weight-loss.tsx",
      "parent": "/(dashboard)/dashboard",
      "children": [
        "/(dashboard)/dashboard/weight-loss/appointments",
        "/(dashboard)/dashboard/weight-loss/medicals",
        "/(dashboard)/dashboard/weight-loss/",
        "/(dashboard)/dashboard/weight-loss/settings/",
        "/(dashboard)/dashboard/weight-loss/support/"
      ]
    },
    "/(public)/_public/appointments": {
      "filePath": "(public)/_public/appointments.tsx",
      "parent": "/(public)/_public",
      "children": [
        "/(public)/_public/appointments/confirmation",
        "/(public)/_public/appointments/error",
        "/(public)/_public/appointments/"
      ]
    },
    "/(public)/_public/consultations": {
      "filePath": "(public)/_public/consultations.tsx",
      "parent": "/(public)/_public",
      "children": [
        "/(public)/_public/consultations/confirmation",
        "/(public)/_public/consultations/error",
        "/(public)/_public/consultations/"
      ]
    },
    "/(public)/_public/contact": {
      "filePath": "(public)/_public/contact.tsx",
      "parent": "/(public)/_public"
    },
    "/(public)/_public/live-consultation": {
      "filePath": "(public)/_public/live-consultation.tsx",
      "parent": "/(public)/_public"
    },
    "/(public)/_public/privacy-policy": {
      "filePath": "(public)/_public/privacy-policy.tsx",
      "parent": "/(public)/_public"
    },
    "/(public)/_public/terms": {
      "filePath": "(public)/_public/terms.tsx",
      "parent": "/(public)/_public"
    },
    "/(public)/_public/welcome": {
      "filePath": "(public)/_public/welcome.tsx",
      "parent": "/(public)/_public"
    },
    "/(dashboard)/dashboard/": {
      "filePath": "(dashboard)/dashboard/index.tsx",
      "parent": "/(dashboard)/dashboard"
    },
    "/(public)/_public/": {
      "filePath": "(public)/_public/index.tsx",
      "parent": "/(public)/_public"
    },
    "/(dashboard)/dashboard/medicals/$program": {
      "filePath": "(dashboard)/dashboard/medicals/$program/route.tsx",
      "parent": "/(dashboard)/dashboard/medicals",
      "children": [
        "/(dashboard)/dashboard/medicals/$program/conditions-allergies",
        "/(dashboard)/dashboard/medicals/$program/payment-history",
        "/(dashboard)/dashboard/medicals/$program/support",
        "/(dashboard)/dashboard/medicals/$program/"
      ]
    },
    "/(dashboard)/dashboard/weight-loss/appointments": {
      "filePath": "(dashboard)/dashboard/weight-loss/appointments.tsx",
      "parent": "/(dashboard)/dashboard/weight-loss",
      "children": [
        "/(dashboard)/dashboard/weight-loss/appointments/$tab",
        "/(dashboard)/dashboard/weight-loss/appointments/booking",
        "/(dashboard)/dashboard/weight-loss/appointments/confirm-reschedule",
        "/(dashboard)/dashboard/weight-loss/appointments/confirmation",
        "/(dashboard)/dashboard/weight-loss/appointments/error",
        "/(dashboard)/dashboard/weight-loss/appointments/reschedule-booking",
        "/(dashboard)/dashboard/weight-loss/appointments/"
      ]
    },
    "/(dashboard)/dashboard/weight-loss/medicals": {
      "filePath": "(dashboard)/dashboard/weight-loss/medicals.tsx",
      "parent": "/(dashboard)/dashboard/weight-loss",
      "children": [
        "/(dashboard)/dashboard/weight-loss/medicals/$tab",
        "/(dashboard)/dashboard/weight-loss/medicals/confirmation",
        "/(dashboard)/dashboard/weight-loss/medicals/error",
        "/(dashboard)/dashboard/weight-loss/medicals/refill-confirmation",
        "/(dashboard)/dashboard/weight-loss/medicals/"
      ]
    },
    "/(public)/_public/appointments/confirmation": {
      "filePath": "(public)/_public/appointments/confirmation.tsx",
      "parent": "/(public)/_public/appointments"
    },
    "/(public)/_public/appointments/error": {
      "filePath": "(public)/_public/appointments/error.tsx",
      "parent": "/(public)/_public/appointments"
    },
    "/(public)/_public/consultations/confirmation": {
      "filePath": "(public)/_public/consultations/confirmation.tsx",
      "parent": "/(public)/_public/consultations"
    },
    "/(public)/_public/consultations/error": {
      "filePath": "(public)/_public/consultations/error.tsx",
      "parent": "/(public)/_public/consultations"
    },
    "/(dashboard)/dashboard/medicals/": {
      "filePath": "(dashboard)/dashboard/medicals/index.tsx",
      "parent": "/(dashboard)/dashboard/medicals"
    },
    "/(dashboard)/dashboard/onboarding/": {
      "filePath": "(dashboard)/dashboard/onboarding/index.tsx",
      "parent": "/(dashboard)/dashboard/onboarding"
    },
    "/(dashboard)/dashboard/settings/": {
      "filePath": "(dashboard)/dashboard/settings/index.tsx",
      "parent": "/(dashboard)/dashboard/settings"
    },
    "/(dashboard)/dashboard/support/": {
      "filePath": "(dashboard)/dashboard/support/index.tsx",
      "parent": "/(dashboard)/dashboard"
    },
    "/(dashboard)/dashboard/urgent-care/": {
      "filePath": "(dashboard)/dashboard/urgent-care/index.tsx",
      "parent": "/(dashboard)/dashboard/urgent-care"
    },
    "/(dashboard)/dashboard/weight-loss/": {
      "filePath": "(dashboard)/dashboard/weight-loss/index.tsx",
      "parent": "/(dashboard)/dashboard/weight-loss"
    },
    "/(public)/_public/appointments/": {
      "filePath": "(public)/_public/appointments/index.tsx",
      "parent": "/(public)/_public/appointments"
    },
    "/(public)/_public/consultations/": {
      "filePath": "(public)/_public/consultations/index.tsx",
      "parent": "/(public)/_public/consultations"
    },
    "/(dashboard)/dashboard/medicals/$program/conditions-allergies": {
      "filePath": "(dashboard)/dashboard/medicals/$program/conditions-allergies.tsx",
      "parent": "/(dashboard)/dashboard/medicals/$program"
    },
    "/(dashboard)/dashboard/medicals/$program/payment-history": {
      "filePath": "(dashboard)/dashboard/medicals/$program/payment-history.tsx",
      "parent": "/(dashboard)/dashboard/medicals/$program"
    },
    "/(dashboard)/dashboard/medicals/$program/support": {
      "filePath": "(dashboard)/dashboard/medicals/$program/support.tsx",
      "parent": "/(dashboard)/dashboard/medicals/$program"
    },
    "/(dashboard)/dashboard/urgent-care/appointments/booking": {
      "filePath": "(dashboard)/dashboard/urgent-care/appointments/booking.tsx",
      "parent": "/(dashboard)/dashboard/urgent-care"
    },
    "/(dashboard)/dashboard/weight-loss/appointments/$tab": {
      "filePath": "(dashboard)/dashboard/weight-loss/appointments/$tab.tsx",
      "parent": "/(dashboard)/dashboard/weight-loss/appointments"
    },
    "/(dashboard)/dashboard/weight-loss/appointments/booking": {
      "filePath": "(dashboard)/dashboard/weight-loss/appointments/booking.tsx",
      "parent": "/(dashboard)/dashboard/weight-loss/appointments"
    },
    "/(dashboard)/dashboard/weight-loss/appointments/confirm-reschedule": {
      "filePath": "(dashboard)/dashboard/weight-loss/appointments/confirm-reschedule.tsx",
      "parent": "/(dashboard)/dashboard/weight-loss/appointments"
    },
    "/(dashboard)/dashboard/weight-loss/appointments/confirmation": {
      "filePath": "(dashboard)/dashboard/weight-loss/appointments/confirmation.tsx",
      "parent": "/(dashboard)/dashboard/weight-loss/appointments"
    },
    "/(dashboard)/dashboard/weight-loss/appointments/error": {
      "filePath": "(dashboard)/dashboard/weight-loss/appointments/error.tsx",
      "parent": "/(dashboard)/dashboard/weight-loss/appointments"
    },
    "/(dashboard)/dashboard/weight-loss/appointments/reschedule-booking": {
      "filePath": "(dashboard)/dashboard/weight-loss/appointments/reschedule-booking.tsx",
      "parent": "/(dashboard)/dashboard/weight-loss/appointments"
    },
    "/(dashboard)/dashboard/weight-loss/medicals/$tab": {
      "filePath": "(dashboard)/dashboard/weight-loss/medicals/$tab.tsx",
      "parent": "/(dashboard)/dashboard/weight-loss/medicals"
    },
    "/(dashboard)/dashboard/weight-loss/medicals/confirmation": {
      "filePath": "(dashboard)/dashboard/weight-loss/medicals/confirmation.tsx",
      "parent": "/(dashboard)/dashboard/weight-loss/medicals"
    },
    "/(dashboard)/dashboard/weight-loss/medicals/error": {
      "filePath": "(dashboard)/dashboard/weight-loss/medicals/error.tsx",
      "parent": "/(dashboard)/dashboard/weight-loss/medicals"
    },
    "/(dashboard)/dashboard/weight-loss/medicals/refill-confirmation": {
      "filePath": "(dashboard)/dashboard/weight-loss/medicals/refill-confirmation.tsx",
      "parent": "/(dashboard)/dashboard/weight-loss/medicals"
    },
    "/(dashboard)/dashboard/medicals/$program/": {
      "filePath": "(dashboard)/dashboard/medicals/$program/index.tsx",
      "parent": "/(dashboard)/dashboard/medicals/$program"
    },
    "/(dashboard)/dashboard/urgent-care/appointments/": {
      "filePath": "(dashboard)/dashboard/urgent-care/appointments/index.tsx",
      "parent": "/(dashboard)/dashboard/urgent-care"
    },
    "/(dashboard)/dashboard/urgent-care/encounters/": {
      "filePath": "(dashboard)/dashboard/urgent-care/encounters/index.tsx",
      "parent": "/(dashboard)/dashboard/urgent-care"
    },
    "/(dashboard)/dashboard/urgent-care/settings/": {
      "filePath": "(dashboard)/dashboard/urgent-care/settings/index.tsx",
      "parent": "/(dashboard)/dashboard/urgent-care"
    },
    "/(dashboard)/dashboard/urgent-care/support/": {
      "filePath": "(dashboard)/dashboard/urgent-care/support/index.tsx",
      "parent": "/(dashboard)/dashboard/urgent-care"
    },
    "/(dashboard)/dashboard/weight-loss/appointments/": {
      "filePath": "(dashboard)/dashboard/weight-loss/appointments/index.tsx",
      "parent": "/(dashboard)/dashboard/weight-loss/appointments"
    },
    "/(dashboard)/dashboard/weight-loss/medicals/": {
      "filePath": "(dashboard)/dashboard/weight-loss/medicals/index.tsx",
      "parent": "/(dashboard)/dashboard/weight-loss/medicals"
    },
    "/(dashboard)/dashboard/weight-loss/settings/": {
      "filePath": "(dashboard)/dashboard/weight-loss/settings/index.tsx",
      "parent": "/(dashboard)/dashboard/weight-loss"
    },
    "/(dashboard)/dashboard/weight-loss/support/": {
      "filePath": "(dashboard)/dashboard/weight-loss/support/index.tsx",
      "parent": "/(dashboard)/dashboard/weight-loss"
    }
  }
}
ROUTE_MANIFEST_END */
